module.exports = __webpack_public_path__ + "288d44b6dbad8c0e0959a940ccba30d4.png";